import { PaymentSchedule } from 'typescript/constants/enums/payment';
import { getCurrencyString } from 'typescript/utilities/currency';
import { getInstallmentMonthsString } from 'typescript/utilities/financing_strings';
import {
  PaymentOption as SelectAndRevealPaymentOption,
  OptionParams,
} from 'typescript/components/select_and_reveal/types';
import { type PaymentOption } from 'typescript/types/api/payment_options';
import { type Offer } from 'typescript/types/api/offers';
import { type TOrderSummary } from 'typescript/types/api/solidshop';
import t from 'typescript/utilities/translate';

export const hasNoIneligibilityReasons = (option: PaymentOption): boolean =>
  !option.ineligibility_reasons?.length;

export const orderHasInstallments = (
  paymentOptions: PaymentOption[],
): boolean => {
  const installmentOption = paymentOptions.find(
    (option) => option.name === PaymentSchedule.INSTALLMENT,
  );

  return Boolean(
    installmentOption && hasNoIneligibilityReasons(installmentOption),
  );
};

export const buildSelectAndRevealOptions = (
  paymentOptions: PaymentOption[],
  offersData: Offer[],
  orderSummaryData: TOrderSummary,
): OptionParams[] => {
  return paymentOptions
    .map((option) => {
      if (option.name === PaymentSchedule.UPFRONT) {
        return {
          option: SelectAndRevealPaymentOption.PAY_IN_FULL,
          overrides: {
            sideLabel: t('checkout.payment_v3.dueToday', {
              amount: getCurrencyString({
                amount: Number(option.price.amount),
                currency: option.price.currency_code,
              }),
            }),
          },
        };
      } else if (
        option.name === PaymentSchedule.INSTALLMENT &&
        hasNoIneligibilityReasons(option)
      ) {
        return offersData
          ? {
              option: SelectAndRevealPaymentOption.PAY_IN_INSTALLMENTS,
              overrides: {
                subtext: getInstallmentMonthsString(offersData),
                sideLabel: t('checkout.payment_v3.dueToday', {
                  amount: getCurrencyString({
                    amount: Number(
                      orderSummaryData.payment_due
                        .installment_first_payment_amount,
                    ),
                    currency: orderSummaryData.payment_due.currency,
                  }),
                }),
              },
            }
          : null;
      }
      return null;
    })
    .filter((option) => option !== null);
};
